import React from 'react';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { renderInBackgroundPriority } from '@atlassian/jira-non-critical/src/BackgroundPriority.tsx';
import { fg } from '@atlassian/jira-feature-gating';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const IssueCreateModalLazyAfterPaint = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-jira-issue-create" */ './index'),
	{ ssr: false },
);

const IssueCreateModal = renderInBackgroundPriority(
	IssueCreateModalLazyAfterPaint,
	() => !fg('jiv-after-paint-issue-create-bundle'),
);

export const AsyncIssueCreateModal = () => {
	return (
		<JiraIssueCreateErrorBoundary
			id="async.jira.issue-create-modal"
			packageName="jiraIssueCreate"
			sendToPrivacyUnsafeSplunk
		>
			<Placeholder name="issue-create-modal" fallback={<></>}>
				<IssueCreateModal />
			</Placeholder>
		</JiraIssueCreateErrorBoundary>
	);
};
